import { GARTask } from "@nens/brostar/uploadapi-client";

import { BrostarUiSchema } from "@/libs/brostar-form";

import { ExplainFieldDataFile } from "../components/explain-field-data";
import { ExplainLabDataFile } from "../components/explain-lab-data";

export const garUiSchema: BrostarUiSchema<GARTask> = {
  projectNumber: {},
  fieldworkFile: {
    "ui:explanation": <ExplainFieldDataFile />,
    "ui:options": {
      accept:
        ".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
    },
  },
  labFile: {
    "ui:explanation": <ExplainLabDataFile />,
    "ui:options": {
      accept:
        ".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
    },
  },
  metadata: {
    "ui:title": "Metadata",
    qualityRegime: {},
    samplingOperator: {
      "ui:widget": "OrganisationSelect",
    },
    samplingStandard: {},
    qualityControlMethod: {},
    responsibleLaboratoryKvk: {
      "ui:widget": "OrganisationSelect",
    },
    deliveryAccountableParty: {
      "ui:widget": "OrganisationSelect",
    },
    groundwaterMonitoringNets: {
      "ui:widget": "GmnSelectTable",
      items: {},
    },
  },
};
